/* Decentní GSAP motion vrstva pro prisaha.cz.
 * Scroll-reveal obsahu sekcí (fade + lehký posun nahoru), jednou.
 * GSAP core + ScrollTrigger jsou ve vendor.js (window.gsap / window.ScrollTrigger).
 * Vše respektuje prefers-reduced-motion; když GSAP chybí, web zůstane statický.
 * Opt-out na konkrétní sekci: <section data-reveal="off"> */
(function () {
	var gsap = window.gsap;
	if (!gsap) return; // vendor nedostupný → žádná chyba, statická stránka

	// reduced-motion → vůbec nic neanimujeme, obsah beze změny
	if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

	var de = document.documentElement;
	var ST = window.ScrollTrigger;
	if (ST && gsap.registerPlugin) gsap.registerPlugin(ST);

	// Spustí cb, až zmizí úvodní loader (homepage); jinak hned (podstránky).
	function whenReady(cb) {
		if (!de.classList.contains('js-loading')) { cb(); return; }
		var tries = 0;
		var iv = setInterval(function () {
			if (!de.classList.contains('js-loading') || ++tries > 60) {
				clearInterval(iv);
				cb();
			}
		}, 100);
	}

	// ---- Scroll-reveal ----------------------------------------------------
	function initReveal() {
		if (!ST) return;
		var sections = [].slice.call(
			document.querySelectorAll('section:not(.page-hero):not([data-reveal="off"])')
		);
		var vh = window.innerHeight || de.clientHeight;

		sections.forEach(function (sec) {
			// Cílem jsou přímé děti hlavních wrapů sekce (hlavička + obsah/mřížka).
			var wraps = [].slice.call(sec.querySelectorAll('.wrap')).filter(function (w) {
				return !w.parentElement || !w.parentElement.closest('.wrap');
			});
			var containers = wraps.length ? wraps : [sec];
			var kids = [];
			containers.forEach(function (c) {
				[].slice.call(c.children).forEach(function (el) {
					if (el.nodeType === 1 && !el.hasAttribute('aria-hidden')) kids.push(el);
				});
			});
			if (!kids.length) return;

			// Co je při načtení už ve výřezu, necháme být → žádné probliknutí.
			if (sec.getBoundingClientRect().top < vh * 0.9) return;

			gsap.set(kids, { autoAlpha: 0, y: 16 });
			ST.create({
				trigger: sec,
				start: 'top 85%',
				once: true,
				onEnter: function () {
					gsap.to(kids, {
						autoAlpha: 1,
						y: 0,
						duration: 0.5,
						ease: 'power2.out',
						stagger: { amount: 0.4 }, // celkový stagger zastropován, ať to není zdlouhavé
						clearProps: 'transform'
					});
				}
			});
		});
	}

	whenReady(function () {
		initReveal();
		if (ST) ST.refresh();
	});
	// Po dokreslení obrázků přepočítat pozice triggerů.
	window.addEventListener('load', function () { if (ST) ST.refresh(); });
})();
